// import _ from 'lodash'
//import React from 'react';
import createHistory from 'history/createBrowserHistory'
import { connect } from 'react-redux'
import { link, namedLink } from 'redux-apis'

import { configureStore, combinedReducers } from './store'
import SaltApi from './saltapi/SaltApi'
import App from './App'

const history = createHistory()

let _store
let _saltApi
let _App

export const getDefaultSettings = () => {
  return {
    TIMEOUT: 20000,
    HEADERS: {Accept: 'application/json'},
    tryAuthFromStorages: false
  }
}

export const getHistory = () => { return history }

export const getSaltApi = (settings, allDocs) => {
  if (_saltApi !== undefined) return _saltApi

  return (_saltApi = new SaltApi(settings, allDocs).init())
}

export const getStore = (settings, allDocs) => {
  if (_store !== undefined) return _store

  const saltApi = getSaltApi(settings, allDocs)
  _store = configureStore(
    saltApi.reducer,
    { api: SaltApi.INITIAL_STATE},
    getHistory())

  _saltApi = link(_store, saltApi, namedLink('api'))

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./saltapi/SaltApi', () => {
      const apiReducer = require('./saltapi/SaltApi').default
      const nextRootReducer = combinedReducers(apiReducer.reducer, history)
      _store.replaceReducer(nextRootReducer)
    })
  }
  return _store
}

export const getConnectedApp = (settings, allDocs) => {
  if (_App !== undefined) return _App

  const saltApi = getSaltApi(settings, allDocs)
  return (_App = connect(saltApi.connector)(App))
}



// WEBPACK FOOTER //
// ./src/utils.js